export default __webpack_public_path__ + "static/media/Pumpkins.80a37f0b.jpg";